import { Navigate, useLocation, Route } from "react-router-dom";
import { ROLES, ROLE_PATH } from "src/constants";
import { get } from "lodash";
import { lazy } from "react";
import AuthLayout from 'src/services/auth/layout/AuthLayout';
import LazyRouteWrapper from "../LazyRouteWrapper";

const Login = lazy(() => import("src/modules/Auth/Login"));
const EmailVerification = lazy(() => import("src/modules/Auth/EmailVerification"));
const Plans = lazy(() => import("src/views/Plans"));
const NewLogin = lazy(() => import("src/services/auth/views/login"));
const Register = lazy(() => import("src/services/auth/views/register"));
const ForgotPassword = lazy(() => import("src/services/auth/views/forgot-password"));
const PhoneVerification = lazy(() => import("src/services/auth/views/phone-verification"));
const ChangePhone = lazy(() => import("src/services/auth/views/change-phone"));
const ResetPassword = lazy(() => import("src/services/auth/views/reset-password"));

const CheckBeforeEnter = (currentUser) => {
    const location = useLocation()

    if (location.pathname === "/merchant/integrations/zid") {
        return <Navigate to="/auth/general" replace />
    } else {
        return currentUser?.role ? <Navigate to={`/${get(ROLE_PATH, currentUser?.role)}`} /> : <AuthLayout />
    }
}

const authRoutes = (currentUser) => (
    <>
        <Route path="auth" element={CheckBeforeEnter(currentUser)}>
            <Route path="general">
                <Route path="" element={<LazyRouteWrapper><NewLogin /></LazyRouteWrapper>} />
                <Route path="register" element={<LazyRouteWrapper><Register /></LazyRouteWrapper>} />
                <Route path="forgot-password" element={<LazyRouteWrapper><ForgotPassword /></LazyRouteWrapper>} />
                <Route path="phone-verification" element={<LazyRouteWrapper><PhoneVerification /></LazyRouteWrapper>} />
                <Route path="change-phone" element={<LazyRouteWrapper><ChangePhone /></LazyRouteWrapper>} />
                <Route path="reset-password" element={<LazyRouteWrapper><ResetPassword /></LazyRouteWrapper>} />
                <Route path="*" element={<LazyRouteWrapper><NewLogin /></LazyRouteWrapper>} />
            </Route>
            <Route path="admin" element={<LazyRouteWrapper><Login role={ROLES.admin} /></LazyRouteWrapper>} />
            <Route path="driver" element={<LazyRouteWrapper><Login role={'driver'} /></LazyRouteWrapper>} />
            <Route path="plans" element={<LazyRouteWrapper><Plans /></LazyRouteWrapper>} />
            {/* <Route path="guard" element={<Login role={ROLES.warehouseGuard} />} /> */}
            <Route path="" element={<Navigate to="merchant" />} />
            <Route path="*" element={<Navigate to="/errors/404" />} />
        </Route>
        <Route path="verify-mail" element={<AuthLayout />}>
            <Route path="" element={<LazyRouteWrapper><EmailVerification /></LazyRouteWrapper>} />
            <Route path="*" element={<Navigate to="/errors/404" />} />
        </Route>
    </>
)

export default authRoutes;
